import React from "react";
import { useDispatch } from "react-redux";
import { deleted, increment, decrement } from "../../redux/product/actions";

function Cartitems({ item }) {
  const { Image, name, Price, Quantity, Category, id } = item;

  const dispatch = useDispatch();

  const indcrementhandeler = () => {
    dispatch(increment(id));
  };

  const decrementhandeler = () => {
    dispatch(decrement(id));
  };
  const delethandeler = () => {
    dispatch(deleted(id));
  };
  return (
    <div className="space-y-6">
      {/* Cart Item */}
      <div className="cartCard">
        <div className="flex items-center col-span-6 space-x-6">
          {/* cart image */}
          <img className="lws-cartImage" src={Image} alt="product" />
          {/* cart item info */}
          <div className="space-y-2">
            <h4 className="lws-cartName">{name}</h4>
            <p className="lws-cartCategory">{Category}</p>
            <p>
              BDT <span className="lws-cartPrice">{Price}</span>
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
          {/* amount buttons */}
          <div className="flex items-center space-x-4">
            <button
              className="lws-incrementQuantity"
              onClick={indcrementhandeler}
            >
              <i className="text-lg fa-solid fa-plus" />
            </button>
            <span className="lws-cartQuantity">{Quantity}</span>
            <button className="lws-decrementQuantity">
              <i
                className="text-lg fa-solid fa-minus"
                onClick={decrementhandeler}
              />
            </button>
          </div>
          {/* price */}
          <p className="text-lg font-bold">
            BDT{" "}
            <span className="lws-calculatedPrice">
              {Number(Math.floor(Price * Quantity))}
            </span>
          </p>
        </div>
        {/* delete button */}
        <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
          <button className="lws-removeFromCart" onClick={delethandeler}>
            <i className="text-lg text-red-400 fa-solid fa-trash" />
          </button>
        </div>
      </div>
      {/* Cart Items Ends */}
    </div>
  );
}

export default Cartitems;
